import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Banner extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Setting the standard for learning, development and care from birth to five',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Seven key features of effective practice',
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'The characteristics of effective teaching and learning',
                },
                {
                    id: 4,
                    icon: 'fa fa-check',
                    title: 'No job is more important than working with children in the early years.',
                },
            ]
        }
    }
    render() {
        return (
            <section className="banner pb-80">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-12 col-lg-6">
                            <div className="banner-content ">
                                <span className="subheading">50% discount on early purchase</span>
                                <h1>Take the next step to School Ready</h1>
                                <ul>
                                    {
                                    this.state.listItem.map((data,i) => (
                                        <li key={i}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                                <Link to="#" className="btn btn-main">Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="banner-img">
                                <img src="assets/images/banner/School_Ready_logo1.svg" alt="" className="img-fluid"/>
                            </div>
                        </div>
                    </div> 
                </div> 
            </section>

        );
    }
}

export default Banner;

